const DESKTOP = "@media (min-width: 1024px)";
const font = '"Instrument Sans", Helvetica, Arial, sans-serif';

export default theme => ({
  root: {
    width: "100%",
    backgroundColor: "#f0f0f0",
    color: "#6b6b6b",
  },
  main: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#f5f5f5",
    borderTop: "1px solid #e3e3e3",
    padding: "24px 16px",
    [DESKTOP]: {
      padding: "40px 16px",
    },
  },
  mainInner: {
    width: "100%",
    maxWidth: 1440,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: 24,
    [DESKTOP]: {
      flexDirection: "row",
      alignItems: "stretch",
      gap: 32,
    },
  },
  brandCol: {
    display: "none",
    [DESKTOP]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      alignSelf: "stretch",
      gap: 12,
      width: 238,
      minWidth: 200,
      flexShrink: 0,
      boxSizing: "border-box",
      paddingRight: 16,
      borderRight: "1px solid #dbdbdb",
    },
  },
  logo: {
    display: "block",
    /* PNG 250×115 con arte útil ~188×64; 120px de ancho ≈ 90px de logo (Figma). */
    width: 120,
    height: "auto",
    objectFit: "contain",
    marginLeft: -15,
  },
  brandText: {
    margin: 0,
    fontFamily: font,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#6b6b6b",
  },
  brandHighlight: {
    margin: 0,
    fontFamily: font,
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#333232",
  },
  social: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  socialIcon: {
    display: "block",
    width: 24,
    height: 24,
  },
  accordionToggle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "none",
    border: 0,
    padding: 0,
    cursor: "pointer",
    fontFamily: font,
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.25,
    color: "#6b6b6b",
    [DESKTOP]: {
      display: "none",
    },
  },
  chevron: {
    width: 16.5,
    height: 9,
    flexShrink: 0,
    display: "block",
    transition: "transform 0.2s ease",
  },
  chevronClosed: {
    transform: "rotate(180deg)",
  },
  columns: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
    [DESKTOP]: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-start",
      gap: 32,
      minWidth: 0,
    },
  },
  col: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    minWidth: 0,
    [DESKTOP]: {
      flex: "1 0 0",
      minWidth: 200,
    },
  },
  colTitle: {
    margin: 0,
    fontFamily: font,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.15,
    color: "#282727",
  },
  contactTitle: {
    color: "#6b6b6b",
  },
  colLinks: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    paddingLeft: 16,
    [DESKTOP]: {
      gap: 8,
      paddingLeft: 0,
    },
  },
  colLink: {
    fontFamily: font,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: 1.5,
    color: "#6b6b6b",
    textDecoration: "none",
    "&:hover": {
      color: "#333232",
    },
  },
  contactRows: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    width: "100%",
  },
  contactRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
  },
  contactIcon: {
    width: 18,
    height: 18,
    flexShrink: 0,
    display: "block",
    objectFit: "contain",
  },
  contactLabel: {
    margin: 0,
    fontFamily: font,
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: 1.2,
    color: "#6b6b6b",
  },
  contactValue: {
    margin: 0,
    fontFamily: font,
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#333232",
    textDecoration: "none",
    "&:hover": {
      color: "#282727",
    },
  },
  legal: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#f0f0f0",
    borderTop: "1px solid #e3e3e3",
    padding: "16px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 16,
  },
  badges: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  },
  dataFiscal: {
    display: "block",
    width: 76,
    height: 36,
    objectFit: "cover",
  },
  legalBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    minHeight: 40,
    padding: "12px 16px",
    borderRadius: 6,
    border: "1px solid #e3e3e3",
    backgroundColor: "#f0f0f0",
    fontFamily: font,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.15,
    color: "#282727",
    textDecoration: "none",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#e8e8e8",
    },
  },
  legalTextLink: {
    fontFamily: font,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.15,
    color: "#6b6b6b",
    textDecoration: "none",
    "&:hover": {
      color: "#282727",
    },
  },
  legalLinks: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 16,
  },
  notice: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#f0f0f0",
    padding: "16px 8px",
  },
  noticeText: {
    margin: 0,
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(10),
    lineHeight: 1.3,
    color: "#6b6b6b",
    textAlign: "center",
  },
  copy: {
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#282727",
    padding: "16px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
  },
  copyText: {
    margin: 0,
    fontFamily: font,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.25,
    color: "#fcfcfc",
    textAlign: "center",
  },
  copyLinks: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    color: "#a8a8a8",
    fontFamily: font,
    fontSize: theme.typography.pxToRem(14),
  },
  copyLink: {
    fontFamily: font,
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.15,
    color: "#a8a8a8",
    textDecoration: "none",
    "&:hover": {
      color: "#fcfcfc",
    },
  },
});
